<template>
<div class="home">
        <div class="home__hero">
            <div class="home__hero-wrap">
                <div class="home__hero-title">Крокодил</div>
                <div class="home__hero-rules">
                    Объясни одно из предложенных слов
                    своей команде - жестами или рисунками.
                </div>
            </div>
        </div>
        <div class="home__plate">
 
            <div class="home__game-nav">
                <div class="home__game-nav-item">
                    <GoBtn @click="newGame">Новая игра</GoBtn>
                </div>
                <SecondBtn v-if="currentGameState"
                           @click="continium">Продолжить
                </SecondBtn>

            </div>

        </div>
    </div>
    
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GoBtn from "../components/GoBtn";
import SecondBtn from "../components/SecondBtn";

export default {
  name: "Home",
  components: { SecondBtn, GoBtn },
  mounted() {
    this.loadingData();
  },
  computed: {
    ...mapGetters(["currentGameState"]),
  },
  methods: {
    newGame() {
      this.cleanAllData();
      this.$router.push("new-game");
    },
    continium() {
      this.$router.push("your-move");
    },
    ...mapActions(["cleanAllData", "loadingData"]),
  },

  data() {
    return {};
  },
};
</script>
<style lang="scss">
.home {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  &__hero {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    color: #fff;
    font-weight: 800;
    padding: 0 20px;
    text-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    &-title {
      font-size: 48px;
      letter-spacing: -0.3px;
    }
  }
  &__plate {
    background: #fff;
    height: auto;
    bottom: 0;
    margin-top: auto;
    width: 100%;
    padding: 45px 30px 30px;
    border-radius: 40px 40px 0 0;
    position: relative;
    box-shadow: 0 -10px 50px rgba(0, 0, 0, 0.1);
  }
  &__game-nav {
    &-item {
      margin-bottom: 10px;
    }
  }
  &__rules {
    padding: 30px 12px;
    text-align: center;
    background: #fafafa;
    color: #666666;
    border-radius: 30px;
    margin-bottom: 50px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    &-img {
      margin-bottom: 8px;
    }
  }
}
</style>
